import DocumentationElement from "./DocumentationElement"
import { ValueTypeDocumentations } from "./ValueTypeDocumentation"
import FAQContent from "../component/FAQContent"
import PRO_DOCU_TREND from "../resources/tutorial/PRO_DOCU_Trend.png"
import PRO_DOCU_Latest_Data from "../resources/tutorial/PRO_DOCU_Latest_Data.png"
import PRO_DOCU_Current_Data from "../resources/tutorial/PRO_DOCU_Current_Data.png"
import PRO_DOCU_Baseline_Data from "../resources/tutorial/PRO_DOCU_Baseline_Data.png"

export const TREND_DOC: DocumentationElement = {
    title: "Trendermittlung",
    content: (
        <div className="flex flex-col space-y-6 p-6 bg-white rounded-lg shadow-lg">
            <div className="tracking-wide">
                <h1 className="font-bold text-xl">Trendermittlung für Ärzt:innen</h1>
                <p>
                    Die <strong>Trend-Einschätzung</strong> ermöglicht Ihnen als Ärzt:in eine schnelle und zuverlässige Beurteilung,
                    ob sich die Werte Ihrer Patient:innen signifikant verändert haben. Dafür wird ein <strong>Hypothesentest </strong>
                    (t-Test für unabhängige Stichproben) durchgeführt, der aktuelle Messwerte mit der Baseline vergleicht.
                    Die Farbe, die an der oberen Kante der Karte angezeigt wird, entspricht der kritischeren der beiden Bewertungen aus "Aktuellste Daten" und "Trend-Einschätzung".
                    Das bedeutet: Ist die "Trend-Einschätzung" orange, bleibt die Karte orange – selbst wenn die "Aktuellste Daten" grün sind.
                </p>

                <h3 className="font-semibold text-lg mt-4">Wie funktioniert die Berechnung?</h3>
                <p>
                    Mithilfe eines <strong>t-Tests</strong> wird geprüft, ob die durchschnittlichen aktuellen Werte der letzten
                    <strong> 14 Tage</strong> sich signifikant von den Baseline-Werten der letzten <strong>90 Tage</strong> unterscheiden.
                    Das heisst im Umkehrschluss, dass eine Trendermittlung erst möglich ist, wenn mindestens 14 Tage an Daten vorliegen.
                    
                </p>

                <h3 className="font-semibold text-lg mt-4">Was ist der p-Wert?</h3>
                <p>
                    Der p-Wert gibt an, wie wahrscheinlich es ist, dass die beobachtete Veränderung zufällig entstanden ist. Eine niedrige p-Wert (z.B. kleiner als 0.01) bedeutet, dass die Wahrscheinlichkeit für einen zufälligen Effekt sehr gering ist, und daher die Veränderung als hochsignifikant betrachtet wird.
                    Das System klassifiziert die Veränderung in vier Stufen:
                </p>

                <h4 className="font-semibold mt-4 text-yellow-500">(Statistisch) Gering signifikante Verschlechterung</h4>
                <p>
                    Der p-Wert  <strong>ist grösser als 0.05</strong>. Es gibt wenig Hinweise auf einen echten Trend (die Veränderung könnte einfach Zufall sein).
                </p>

                <h4 className="font-semibold mt-4 text-amber-500">(Statistisch) Mäßig signifikante Verschlechterung</h4>
                <p>
                    Der p-Wert liegt zwischen <strong>0.01 und 0.05</strong>. Es gibt Hinweise auf eine Verschlechterung des Trends.
                </p>

                <h4 className="font-semibold mt-4 text-orange-500">(Statistisch) Deutlich signifikante Verschlechterung</h4>
                <p>
                    Der p-Wert liegt zwischen <strong>0.01 und 0.001</strong>. Es gibt deutliche Hinweise auf eine Verschlechterung des Trends.
                </p>

                <h4 className="font-semibold mt-4 text-red-600">(Statistisch) Stark signifikante Verschlechterung</h4>
                <p>
                    Der p-Wert liegt unter <strong>0.001</strong>. Es gibt sehr deutliche Hinweise auf eine Verschlechterung des Trends.
                </p>

                <h4 className="font-semibold mt-4 text-green-600">(Trend-Verbesserung)</h4>
                <p>
                    Eine Verbesserung wird immer mit <strong>grüner Farbe</strong> dargestellt, unabhängig vom p-Wert. Dies könnte auf eine <strong>erfolgreiche Behandlung</strong> hindeuten.
                </p>

            </div>

            {/* Bild bleibt innerhalb der Card */}
            <div className="w-full flex justify-center">
                <img src={PRO_DOCU_TREND} alt="Trendermittlung" className="rounded shadow-md max-w-full" />
            </div>
        </div>
    )
}

export const DATA_AGGREGATION_DOC: DocumentationElement = {
    title: "Datenaggregation",
    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
}

export const LATEST_VALUE_DOC: DocumentationElement = {
    title: "Aktuellster Wert",
    content: (
        <div className="flex flex-col space-y-6 p-6 bg-white rounded-lg shadow-lg">
            <h1 className="font-bold text-xl">Aktuellster Wert</h1>
            <p>
                Der <strong>aktuellste Wert</strong> gibt Ihnen als Ärzt:in eine Momentaufnahme über den letzten Messwert der Patient:in.
                Dieser Wert kann als erste Einschätzung dienen, sollte jedoch im Kontext der gesamten Daten betrachtet werden.
            </p>
            <p>
                <strong>Was bedeutet der Wert?</strong>
                <br />
                - Er zeigt Ihnen den letzten dokumentierten Gesundheitsstatus der Patient:in.
                <br />
                - Je nach Skala kann er von einer normalen bis hin zu einer kritischen Veränderung reichen.
            </p>
            <p>
                Im angezeigten Beispiel sehen Sie den aktuellsten Wert einer Patient:in.
                Die Farbskala rechts gibt Ihnen eine schnelle Einschätzung über den Zustand.
                Die Farbe, die an der oberen Kante der Karte angezeigt wird, entspricht der kritischeren der beiden Bewertungen aus "Aktuellste Daten" und "Trend-Einschätzung".
                Das bedeutet: Ist die "Trend-Einschätzung" orange, bleibt die Karte orange – selbst wenn die "Aktuellste Daten" grün sind.
            </p>
            <div className="w-full flex justify-center">
                <img src={PRO_DOCU_Latest_Data} alt="Aktuellster Wert" className="rounded shadow-md max-w-full" />
            </div>
        </div>
    )
}

export const CURRENT_DATA_DOC: DocumentationElement = {
    title: "Aktuelle Daten (14 Tage)",
    content: (
        <div className="flex flex-col space-y-6 p-6 bg-white rounded-lg shadow-lg">
            <h1 className="font-bold text-xl">Aktuelle Daten (14 Tage)</h1>
            <p>
                Diese Ansicht zeigt Ihnen den Verlauf der Patient:in über die letzten <strong>14 Tage</strong>.
                Sie können hier kurzfristige Trends erkennen und Veränderungen über zwei Wochen hinweg analysieren.
            </p>
            <p>
                <strong>Worauf sollten Sie achten?</strong>
                <br />
                - Gibt es signifikante Anstiege oder Abfälle?
                <br />
                - Ist ein stabiler Verlauf erkennbar oder gibt es starke Schwankungen?
            </p>
            <p>
                Das Bild zeigt eine typische 14-Tage-Datenansicht mit tagesaktuellen Werten. Die blaue Kurve stellt den Verlauf der gemessenen Werte dar.
            </p>
            <div className="w-full flex justify-center">
                <img src={PRO_DOCU_Current_Data} alt="Aktuelle Daten (14 Tage)" className="rounded shadow-md max-w-full" />
            </div>
        </div>
    )
}

export const BASELINE_DATA_DOC: DocumentationElement = {
    title: "Baseline Daten (90 Tage)",
    content: (
        <div className="flex flex-col space-y-6 p-6 bg-white rounded-lg shadow-lg">
            <h1 className="font-bold text-xl">Baseline Daten (90 Tage)</h1>
            <p>
                Die <strong>Baseline-Daten</strong> stellen den Referenzwert der Patient:in über die letzten <strong>90 Tage</strong> dar.
                Sie sind essenziell für den Vergleich mit aktuellen Messwerten und helfen Ihnen, langfristige Trends zu erkennen.
            </p>
            <p>
                <strong>Warum sind diese Daten wichtig?</strong>
                <br />
                - Sie zeigen das übliche Gesundheitsniveau der Patient:in.
                <br />
                - Sie ermöglichen eine verlässliche Beurteilung von Veränderungen.
            </p>
            <p>
                Das Bild zeigt die Langzeitdaten über 90 Tage hinweg. Die Werte können natürliche Schwankungen enthalten, aber signifikante Abweichungen sind ein Hinweis auf Veränderungen im Gesundheitszustand.
            </p>
            <div className="w-full flex justify-center">
                <img src={PRO_DOCU_Baseline_Data} alt="Baseline Daten (90 Tage)" className="rounded shadow-md max-w-full" />
            </div>
        </div>
    )
}

export const TUTORIAL_DOC: DocumentationElement = {
    title: "FAQ",
    content: <FAQContent display={"professional"} />
}

const Documentation: DocumentationElement[] = [
    TUTORIAL_DOC,
    ...ValueTypeDocumentations,
    TREND_DOC,
    LATEST_VALUE_DOC,
    CURRENT_DATA_DOC,
    BASELINE_DATA_DOC,
]

export default Documentation
